// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./wwwroot/client/common/common.scss
// module id = 2
// module chunks = 1